



































import Vue from 'vue';
import AirbaseInfo from '@/classes/airbase/airbaseInfo';

export default Vue.extend({
  components: {},
  name: 'AirbaseTarget',
  props: {
    value: {
      type: AirbaseInfo,
      required: true,
    },
    battleCount: {
      type: Number,
      required: true,
    },
    handleClose: {
      type: Function,
    },
  },
  data: () => ({}),
  computed: {
    info(): AirbaseInfo {
      return this.value;
    },
  },
  methods: {
    close() {
      this.handleClose();
    },
  },
});
